module.exports = __webpack_public_path__ + "2c96e50ccde92d360689e5f4acaa9b20.png";